import { UMA_CASH_LIMIT, UMA_IDENTIFICATION, UMA_NOTICE, VAT_RATE } from "./constants";
import { roundCents } from "./money";
import type { Operation } from "./types";

/** The three legal thresholds converted to MXN for a given daily UMA value. */
export interface Thresholds {
  /** Operations at or above this amount (without VAT) require identifying the client. */
  identification: number;
  /** Operations at or above this amount (without VAT), alone or accumulated, require a notice (Aviso). */
  notice: number;
  /** Cash payments at or above this amount (WITH VAT) are prohibited (art. 32). */
  cashLimit: number;
}

export function computeThresholds(umaValue: number): Thresholds {
  return {
    identification: roundCents(UMA_IDENTIFICATION * umaValue),
    notice: roundCents(UMA_NOTICE * umaValue),
    cashLimit: roundCents(UMA_CASH_LIMIT * umaValue),
  };
}

/** Amount including VAT. Only the cash limit is compared with VAT. */
export const withVat = (amount: number) => roundCents(amount * (1 + VAT_RATE));

export type OperationLevel = "notice" | "identification" | "below_threshold";

/** Which threshold an operation reaches on its own (amounts are compared without VAT). */
export function operationLevel(amount: number, thresholds: Thresholds): OperationLevel {
  if (amount >= thresholds.notice) return "notice";
  if (amount >= thresholds.identification) return "identification";
  return "below_threshold";
}

export function exceedsCashLimit(
  operation: Pick<Operation, "paymentMethod" | "amount">,
  thresholds: Thresholds,
): boolean {
  return operation.paymentMethod === "cash" && withVat(operation.amount) >= thresholds.cashLimit;
}
